import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * POST /api/v2/process/:id/draft/nodes/merge — merge two draft cards
 *
 * Folds the `mergedStableStepId` node into `survivorStableStepId`: everything
 * pointing at the merged node is rewired onto the survivor, the merged node's
 * predecessors and accumulable content (helpers, whoElseDoesThis) are unioned
 * into the survivor, and the merged node is deleted. The survivor's kind is
 * the result kind, so a cross-kind merge (task ↔ assignment) keeps the
 * survivor's collection and drops the merged node's kind-specific content.
 *
 * Both ids live in the shared `stableStepId` space (steps + assignments); the
 * backend resolves each across both collections. Event nodes are not mergeable.
 * The response is the shared `DraftNodeEnvelopeSchema`.
 */ export const MergeDraftNodesRequestSchema = z.object({
    survivorStableStepId: ObjectIdSchema,
    mergedStableStepId: ObjectIdSchema
});

//# sourceMappingURL=merge-draft-nodes.schema.js.map